<template>
  <div class="row">

    <div class="col-md-12 mb-2">
      <div class="card p-2 mb-2">
        <form @submit="applyMapFilter">
          <div class="row">
            <div class="col-md-2">
              <div class="h-100 d-flex justify-content-start align-items-center flex-column ps-3" style="font-size:11px;">
                <div class="d-flex mb-1 justify-content-start w-100 align-items-center">
                  <div style="background-color:#BDCCD4;width:10px;height:10px;" class="rounded-circle me-3"></div>
                  <span class="me-3">MAKS Customer Base</span>
                </div>
                <div class="d-flex mb-1 justify-content-start w-100 align-items-center">
                  <div style="background-color:#51E1E5;width:10px;height:10px;" class="me-3"></div>
                  <span>MAKS Partners</span>
                </div>
              </div>
            </div>
            <div class="col-md-2">
              <select class="form-select w-100 rounded-0" style="height: 45px;" v-model="selectType">
                <option value="all">All</option>
                <option value="partners">Partners</option>
                <option value="customers">Customer Base</option>
              </select>
            </div>
            <div class="col-md-2">
              <country-select className="form-select w-100 rounded-0" style="height: 45px;" v-model="selectCountry" :country="selectCountry" topCountry="US" placeholder="Country"/>
            </div>
            <div class="col-md-2">
              <region-select className="form-select w-100 rounded-0" style="height: 45px;" v-model="selectState" :country="selectCountry" :region="selectCountry" defaultRegion="'US'" placeholder="Region"/>
            </div>
            <div class="col-md-2">
              <button type="submit" class="btn btn-primary w-100"><i class="fa-duotone fa-solid fa-filter me-1"></i> Apply Filter</button>
            </div>
            <div class="col-md-2">
              <button type="button" class="btn btn-secondary w-100" @click="clearMapFilter"><i class="fa-duotone fa-solid fa-filter-slash me-1"></i> Clear Filter</button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="col-md-12">
      <div class="">
        <div id="chartdiv" style="height: 700px;">
        </div>
      </div>
    </div>
  </div>
</template>
    
<script lang="js">
import { defineComponent } from 'vue'
//import UnderConstruction from '../components/UnderConstruction';
import Mixin from '../mixins/global.mixin'
import * as am5 from '@amcharts/amcharts5';
import * as am5map from "@amcharts/amcharts5/map";
import am5geodata_worldLow from "@amcharts/amcharts5-geodata/worldLow";
//import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';
import appConstants from '@/constants/app.constants';
import $ from 'jquery';
import axios from 'axios';
  
export default defineComponent({
  name: 'PartnersCustomersHeatmap',
  mixins: [Mixin],
  setup() {
    return {
      constants: appConstants
    }
  },
  data() {
    return {
      resellerData: [],
      customerStateCounts: [],
      chart: null,
      mapRoot: null,
      partnerPointerSeries: null,
      customerBubbleSeries: null,
      partnersMarkerColor: '#51E1E5',
      customerBaseMarkerColor: '#BDCCD4',
      mapBackgroundColor: '#EBF1F2',
      selectCountry: 'US',
      selectState: '',
      selectType: '',
    }
  },
  components: {
  },
  methods: {
    clearMapFilter: function () {
      this.selectCountry = 'US';
      this.selectState = '';
      this.selectType = appConstants.MARKER_TYPE.ALL;
      this.applyMapFilter();
    },
    applyMapFilter: async function () {
      event.preventDefault();
      this.toggleFullScreenSpinner(true);
      this.resellerData = [];
      this.customerStateCounts = [];
      $('#chartdiv').empty();
      this.showMapSpinner = true;
      try {
        switch (this.selectType) {
          case appConstants.MARKER_TYPE.PARTNERS:
            await Promise.all([this.getResellerCoordinates()]);
            await this.afterBothComplete();
            break;
          case appConstants.MARKER_TYPE.CUSTOMERS:
            await Promise.all([this.getCustomerPerStateCountryData()]);
            await this.afterBothComplete();
            break;
          default:
            await Promise.all([this.getCustomerPerStateCountryData(), this.getResellerCoordinates()]);
            await this.afterBothComplete();
            break;
        }
      } catch (error) {
        console.error('Error running functions:', error);
      }
    },
    getCustomerPerStateCountryData: async function () {
      this.customerStateCounts = [];
      var urls = [];
      
      let url = appConstants.SITEURL+'/wp-json/custom-api/v1/order_counts/';
      switch (true) {
        case (this.selectState != '' && this.selectCountry == 'US'):
          url = url + 'state/'+this.selectState;
          urls.push(url);
          break;
        case (this.selectState == '' && this.selectCountry == 'US'):
          url = url + 'state/';
          urls.push(url);
          break;
        case (this.selectState == '' && this.selectCountry != 'US' && this.selectCountry != ''):
          url = url + 'country/'+ this.selectCountry;
          urls.push(url);
          break;
        case (this.selectCountry == '' && this.selectState == ''):
          //url = url + 'country/';
          urls.push(url + 'country/');
          urls.push(url + 'state/');
          break;	
      }
      
      let currentPage = 1;
      let totalUrls = urls.length;
      while (currentPage <= totalUrls) {
        try {
          var currentUrl = urls[currentPage-1];
          var response = await axios.get(currentUrl);
          
          if (currentUrl.includes('country')) {
            Object.keys(response.data).forEach((country, idx, array) => {
              var countryData = this.getLatLangPerCountry(country);
              if (countryData) {
                this.customerStateCounts.push({
                  id: country,
                  properties: {
                    name: countryData.name,
                  },
                  name: countryData.name,
                  value: parseInt(response.data[country]),
                  circleTemplate: { fill: this.customerBaseMarkerColor },
                  geometry: {
                    type: "Point",
                    coordinates: countryData.coordinates
                  }
                });
              }
              if ((idx+1 == array.length) && (currentPage == totalUrls)) {
                return this.customerStateCounts;
              }
            });
          } else {
            Object.keys(response.data).forEach((state, idx, array) => {
              if (appConstants.STATES[state]) {
                //var st8 = appConstants.STATES[state];
                this.customerStateCounts.push({
                  id: state,
                  properties: {
                    name: appConstants.STATES[state],
                  },
                  name: appConstants.STATES[state],
                  value: parseInt(response.data[state]),
                  circleTemplate: { fill: this.customerBaseMarkerColor },
                  geometry: {
                    type: "Point",
                    coordinates: this.getLatLangPerRegion(state).reverse()
                  }
                });
              }
              if ((idx+1 == array.length) && (currentPage == totalUrls)) {
                return this.customerStateCounts;
              }
            });
          }
          currentPage = currentPage + 1;
        } catch (error) {
          console.error(`Error:`, error);
        }
      }	
    },
    getResellerCoordinates: async function () {
      this.resellerData = [];
      
      let currentPage = 1;
      let totalPages = 1;

      while (currentPage <= totalPages) {
        try {
          // Make the API request
          var response = await axios.get(appConstants.SERVICESURL+'/api/v1/resellers/coordinates?page='+currentPage+'&country='+this.selectCountry+'&state='+this.selectState);

          // Extract the data and pagination info
          const data = response.data;
          totalPages = data.total_pages; // Update this depending on how your API returns total pages

          // Append the current page's data to the allData array
          data.resellers.forEach((partner, idx, array) => {
            this.resellerData.push({
              id: partner.id,
              properties: {
                name: partner.business_name,
              },
              name: partner.business_name,
              value: 1,
              circleTemplate: { fill: this.partnersMarkerColor },
              geometry: {
                type: "Point",
                coordinates: [partner.longitude, partner.latitude]
              }
            });
            
            if ((idx+1 == array.length) && (currentPage == totalPages)) {
              return this.resellerData;
            }
          });

          // Increment the current page
          currentPage++;
        } catch (error) {
          console.error(`Error fetching page ${currentPage}:`, error);
          break; // Break the loop if an error occurs
        }
      }
    },
    afterBothComplete: async function() {
      this.toggleFullScreenSpinner(false);
      let root =  await Promise.all([this.createAmCharts5Map()]);
      if (root.length) {
        this.showMapSpinner = false;
        if (this.customerStateCounts.length) {
          this.createCustomerHeatMapMarkers(root[0]);
        }
        if (this.resellerData.length) {
          this.createResellerMarkers(root[0]);
        }
      }
      //console.log('Both functions are complete');
    },
    runFunctions: async function () {
      try {
        //const results = 
        await Promise.all([this.getCustomerPerStateCountryData(), this.getResellerCoordinates()]);
        //console.log('Results:', results);
        await this.afterBothComplete();
      } catch (error) {
        console.error('Error running functions:', error);
      }
    },
    createCustomerHeatMapMarkers: function (root) {
      var circleTemplate = am5.Template.new({
        tooltipText: "{name}: {value}"
      });

      this.customerBubbleSeries = this.chart.series.push(
        am5map.MapPointSeries.new(root, {
          calculateAggregates: true,
          valueField: "value",
        })
      );

      this.customerBubbleSeries.bullets.push(function () {
        return am5.Bullet.new(root, {
          sprite: am5.Circle.new(root, {
            radius: 10,
            templateField: "circleTemplate"
          }, circleTemplate)
        });
      });

      this.customerBubbleSeries.set("heatRules", [{
        target: circleTemplate,
        min: 5,
        max: 60,
        key: "radius",
        dataField: "value"
      }]);
      
      this.customerBubbleSeries.data.setAll(this.customerStateCounts);
    },
    createResellerMarkers: function (root) {
      // Create point series
        this.partnerPointerSeries = this.chart.series.push(
          am5map.MapPointSeries.new(root, {
            calculateAggregates: true,
            valueField: "value",
            dataField: "value",
            polygonIdField: "id"
          })
        );
        this.partnerPointerSeries.bullets.push((root, series, dataItem) => {
          var container = am5.Container.new(root, {});
          var square = container.children.push(am5.Rectangle.new(root, {
            width: 10,
            height: 10,
            fill: this.partnersMarkerColor,
            centerX: am5.p50,
            centerY: am5.p50
          }));
          square.set("tooltipText", dataItem.dataContext.properties.name);

          return am5.Bullet.new(root, {
            sprite: container
          });
        });
        this.partnerPointerSeries.data.setAll(this.resellerData);
    },
    createAmCharts5Map: function () {
      var root = null;
      am5.ready(() => {
        //console.log(am5.Root);
        am5.disposeAllRootElements();
        root = am5.Root.new("chartdiv");
        root.setThemes([
          am5themes_Animated.new(root)
        ]);

        this.chart = root.container.children.push(
          am5map.MapChart.new(root, {
            homeZoomLevel: 12,
            homeGeoPoint: {
              longitude: -100.17232754112253,
              latitude: 39.72231405286368
            },
            projection: am5map.geoMercator()
          })
        );

        var backgroundSeries = this.chart.series.push(am5map.MapPolygonSeries.new(root, {}));
        backgroundSeries.mapPolygons.template.setAll({
          fill: root.interfaceColors.get("alternativeBackground"),
          fillOpacity: 0,
          strokeOpacity: 0,
        });

        backgroundSeries.data.push({
          geometry: am5map.getGeoRectangle(90, 180, -90, -180)
        });

        var polygonSeries = this.chart.series.push(
          am5map.MapPolygonSeries.new(root, {
            geoJSON: am5geodata_worldLow,
            exclude: ["AQ"]
          })
        );

        polygonSeries.mapPolygons.template.setAll({
          //fill: root.interfaceColors.get("alternativeBackground"),
          fill: am5.color(this.mapBackgroundColor),
          strokeWidth: 0.5,
          stroke: root.interfaceColors.get("background")
        });
        
        polygonSeries.events.on("datavalidated", () => {
          this.chart.goHome();
        });

      }); // end am5.ready() 

     
      return root;
      
    },
    // initMap: async function () {
    //   let root = await Promise.all([this.createAmCharts5Map()]);
    //   if (root.length) {
    //     this.createMaksMarker(root[0]);
    //   }
    // }
  },
  beforeMount () {
    this.runFunctions();
  },
  mounted() {
    this.selectCountry = 'US';
    this.selectType = appConstants.MARKER_TYPE.ALL;
    setTimeout( () => {
      //this.toggleFullScreenSpinner(false);
    }, 500);
  }
});
</script>
    